// smooth scroll
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('smooth-wrapper');
  var content = document.getElementById('smooth-content');
  if (!wrapper || !content || typeof gsap === 'undefined' || typeof ScrollSmoother === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

  var isMobile = window.innerWidth < 768;

  ScrollSmoother.create({
    wrapper: wrapper,
    content: content,
    smooth: isMobile ? 1 : 1.8,
    effects: !isMobile,
    smoothTouch: 0.1,
    normalizeScroll: true,
    ignoreMobileResize: true,
  });
});

// Msk phone
var $input = document.querySelectorAll('input[type=tel]');
$input.forEach(function (el) {
  el.addEventListener('input', handleInput, false);
  function handleInput(e) {
    e.target.value = phoneMask(e.target.value);
  }
});

function phoneMask(phone) {
  return phone
    .replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{2})(\d)/, '$1) $2')
    .replace(/(\d{1,5})(\d{4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
}
